<p-fileUpload
  *transloco="let t"
  #fileUploader
  class="block"
  [customUpload]="true"
  mode="advanced"
  [accept]="acceptedFileTypes"
  [maxFileSize]="maxFileSize"
  (uploadHandler)="upload($event, fileUploader)"
  [fileLimit]="fileLimit"
  [auto]="auto"
  [showUploadButton]="!auto"
  [disabled]="disabled"
  [showCancelButton]="false"
  chooseIcon="icon-folderOpen-fill relative -top-2px"
  uploadIcon="icon-upload-fill relative -top-2px"
  cancelIcon="icon-close-outline"
  [withCredentials]="true"
  [chooseLabel]="t('choose')"
  [uploadLabel]="t('upload')"
  [cancelLabel]="t('cancel')"
  >
  <ng-template #file let-file>
    <table class="min-w-full text-left ng-star-inserted">
      <tr>
        <td>
          <div class="relative pr-8">
            {{ file.name }}
            <br />
            <span class="text-sm text-grey-medium/70">{{
              file.size | filesize
            }}</span>
          </div>
        </td>
        <td>
          <span
            class="float-right cursor-pointer icon-close-outline hover:text-status-red"
            (click)="fileUploader.clear()"
          ></span>
        </td>
      </tr>
    </table>
  </ng-template>
  <ng-template #content let-files>
    @if (fileUploader.fileLimit! > fileUploader.files.length) {
      <div
        class="p-8 text-center border-2 border-dashed cursor-pointer border-grey-light hover:border-grey-default/50 text-grey-default/75 hover:text-grey-default/50"
        (click)="fileUploader.choose()"
        >
        <p class="p-2 italic no-select">
          {{ t("drag_file_hint") }}
        </p>
      </div>
    }
  </ng-template>
</p-fileUpload>
